// import { type FieldValues, Form, useForm } from 'react-hook-form';
import { PageBody } from '@library/components/layout/PageBody';
import {
  PlayerPackDetailsHeader
  // PlayerPackProjectionsTable,
  // PlayerPacksFormFields
} from '@bo-components/playerPacks';
// import { StyledCard } from '@bo-components/common/StyledComponents';
// import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
// import { usePlayerPacksTable } from '@bo-hooks/playerPacks/usePlayerPacksTable';

export const PlayerPackDetails = () => {
  // const { playerPacks } = usePlayerPacksTable();
  const { playerPackId = '' } = useParams<{
    playerPackId: string;
  }>();

  // const playerPack = useMemo(() => {
  //   return playerPacks.find((pack) => pack.id === playerPackId);
  // }, [playerPacks, playerPackId]);

  // const formMethods = useForm({
  //   defaultValues: {
  //     createdAt: playerPack?.createdAt,
  //     fadeMultiplier: playerPack?.fadeMultiplier,
  //     fadeWagerId: playerPack?.fadeWagerId,
  //     id: playerPack?.id,
  //     imageUrl: playerPack?.imageUrl,
  //     placeByTime: playerPack?.placeByTime,
  //     stateRestrictions: playerPack?.stateRestrictions,
  //     tailMultiplier: playerPack?.tailMultiplier,
  //     tailWagerId: playerPack?.tailWagerId,
  //     title: playerPack?.title
  //   } as FieldValues
  // });

  // if (!playerPack) {
  return (
    <>
      <PlayerPackDetailsHeader title={`Player Pack #${playerPackId}`} />
      <PageBody>
        <div className="text-soClean-100">Player Pack not found</div>
      </PageBody>
    </>
  );
};

// return (
//   <>
//     <PlayerPackDetailsHeader title={`Player Pack #${playerPackId}`} />
//     <PageBody className="flex gap-4">
//       <StyledCard title="Details" className="flex grow">
//         <Form
//           control={formMethods.control}
//           className="flex size-full flex-wrap gap-4 py-2"
//         >
//           <PlayerPacksFormFields formMethods={formMethods} isReadOnly />
//         </Form>
//       </StyledCard>
//       <StyledCard title="Lineup" className="grow-[2]">
//         <PlayerPackProjectionsTable
//           playerPackProjections={playerPack.picks}
//         />
//       </StyledCard>
//     </PageBody>
//   </>
// );
// };
